import React from 'react';
import { Navigate } from 'react-router-dom';
import { appLinks } from 'src/components/web/constants';
import { useAdmin } from './AdminContext';

interface AdminRouteProps {
  isLoggedIn: boolean;
  children: React.ReactNode;
}

/**
 * Protects admin routes. Requires login and admin role. Non-admins are redirected to main page.
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ isLoggedIn, children }) => {
  const { isAdmin, loading } = useAdmin();

  if (!isLoggedIn) {
    return <Navigate to={appLinks.LOGIN} replace />;
  }
  if (!loading && !isAdmin) {
    return <Navigate to={appLinks.MAIN_PAGE} replace />;
  }
  if (loading) {
    return (
      <div className="flex flex-1 justify-center items-center min-h-[200px]">
        <p className="text-gray-500 text-sm">Loading…</p>
      </div>
    );
  }
  return <>{children}</>;
};

export default AdminRoute;
